import * as React from "react"
import { useState } from "react"
import { Link, navigate } from "gatsby"
import firebase from "gatsby-plugin-firebase"
import MuiAlert from '@material-ui/lab/Alert';

import { TextField, Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Button, CircularProgress, Snackbar } from "@material-ui/core"

import ImgLogo from "../images/logo.png"
import ImgBoatIcon from "../images/boat-icon.svg"

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

// markup
const Header = (props) => {
  const [alertDialogOpen, setAlertDialogOpen] = useState(false);

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState(false);

  let signIn = async () => {
    if (!email || !password) {
      setValidated(true);
      return;
    }

    setLoading(true);

    try {
      let res = await firebase.auth().signInWithEmailAndPassword(email, password);
      if (res.user)
        navigate("/dashboard", { replace: true });

    } catch (e) {
      console.log(e);
      setSnackbarMessage(e.message);
      setSnackbarOpen(true);
    }
    setLoading(false);
  }

  return (
    <header className="absolute top-0 left-0 right-0 bg-transparent z-30 opacity-100">
      <div className="h-24 flex px-6 md:px-4 py-6 items-center bg-transparent" >
        
        <div className="flex items-center hidden md:flex ">

          <div className="w-full py-2 px-2" style={{maxWidth: "8rem"}}>
            <TextField
              id="username"
              size="small"
              label="Client login"
              type="text"
              variant="outlined"
              value={email}
              error={validated && !email}
              helperText={validated && !email ? "Email cannot be empty" : ""}
              disabled={loading}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="w-full px-2 py-2" style={{maxWidth: "8rem"}}>
            <TextField
              id="password"
              size="small"
              label="Password"
              type="password"
              variant="outlined"
              value={password}
              error={validated && !password}
              helperText={validated && !password ? "Password cannot be empty" : ""}
              disabled={loading}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
        </div>

        <div className="w-9 h-9 hidden md:flex justify-center items-center rounded-full md:ml-4 mr-24 cursor-pointer bg-blue-500"
          onClick={() => {
            if (loading) return;
            signIn();
          }}>
          {loading ? (<CircularProgress size={30} color="white" />) : (<img src={ImgBoatIcon} alt="boat icon" className="w-5" />)}

        </div>
        <Link to="/login" className="md:hidden bg-blue-400 px-8 py-3 text-white font-bold tracking-wide text-sm">
          Client login
        </Link>
      </div>

      
      <Dialog
        open={alertDialogOpen}
        onClose={() => setAlertDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Sign in</DialogTitle>
        <DialogContent>
          <div className="bg-white px-16 py-8 w-full shadow-3xl">
            <div className="py-8 flex flex-wrap">
              <div className="w-full py-2 px-2">
                <TextField
                  id="email"
                  size="small"
                  label="Email Address"
                  fullWidth
                  type="email"
                  variant="outlined"
                  value={email}
                  error={validated && !email}
                  helperText={validated && !email ? "Email cannot be empty" : ""}
                  disabled={loading}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="w-full px-2 py-2">
                <TextField
                  id="password"
                  size="small"
                  label="Password"
                  fullWidth
                  type="password"
                  variant="outlined"
                  value={password}
                  error={validated && !password}
                  helperText={validated && !password ? "Password cannot be empty" : ""}
                  disabled={loading}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>
            <div className="py-4 shadow-inner shadow-md cursor-pointer hover:shadow-sm uppercase text-sm font-bold 
                text-white tracking-wide text-center bg-blue-500" onClick={() => {
                if (loading) return;
                signIn();
              }}>
              {loading ? (<CircularProgress size={30} color="white" />) : "Sign in"}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertDialogOpen(false)} color="primary">
            Okay
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)}>
        <Alert onClose={() => setSnackbarOpen(false)} severity="error">
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </header>
  )
}

export default Header
